import React from "react";
import PropType from "prop-types";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import { connect } from "react-redux";
import { MenuItem } from "@fluentui/react-components";
import CommonTooltip from "../common/CommonTooltip";
import { useTranslation } from "react-i18next";
import { Undo, Redo } from "lucide-react";
import { t } from "i18next";
import { useSelector } from "react-redux";
import TrackedButton from "../common/TrackedButton";

// Below disables intentional, sonar exception for connecting UndoRedo with state provider
// eslint-disable-next-line prettier/prettier
let UndoRedo = ({ canUndo, canRedo, onUndo, onRedo, undoLength, redoLength }) /* NOSONAR */ => {
  const { t } = useTranslation();

  return (
    <>
      <MenuItem onClick={onUndo} disabled={!canUndo} secondaryContent={"CTRL+Z"}>
        {t("menu.undo")} {canUndo ? "(" + undoLength + ")" : ""}
      </MenuItem>
      <MenuItem onClick={onRedo} disabled={!canRedo} secondaryContent={"CTRL+Y"}>
        {t("menu.redo")} {canRedo ? "(" + redoLength + ")" : ""}
      </MenuItem>
    </>
  );
};

UndoRedo.propTypes = {
  canUndo: PropType.bool,
  canRedo: PropType.bool,
  onUndo: PropType.func,
  onRedo: PropType.func,
  undoLength: PropType.number,
  redoLength: PropType.number,
};

// eslint-disable-next-line prettier/prettier
let UndoRedoButtons = ({ canUndo, canRedo, onUndo, onRedo, undoLength, redoLength }) /* NOSONAR */ => {
  const uiScale = useSelector((state) => state.preferences.uiScale);
  const iconStyle = {
    width: 24 * uiScale,
    height: 24 * uiScale,
  };
  const buttonStyle = {
    minWidth: 0,
    minHeight: 0,
    width: 32 * uiScale,
    height: 32 * uiScale,
  };

  return (
    <>
      <CommonTooltip content={t("tooltip.undo") + (canUndo ? " (" + undoLength + ")" : "")} positioning="after">
        <TrackedButton
          icon={<Undo style={iconStyle} />}
          style={buttonStyle}
          onClick={onUndo}
          disabled={!canUndo}
          appearance="subtle"
          size="small"
        />
      </CommonTooltip>
      <CommonTooltip content={t("tooltip.redo") + (canRedo ? " (" + redoLength + ")" : "")} positioning="after">
        <TrackedButton
          icon={<Redo style={iconStyle} />}
          style={buttonStyle}
          onClick={onRedo}
          disabled={!canRedo}
          appearance="subtle"
          size="small"
        />
      </CommonTooltip>
    </>
  );
};

UndoRedoButtons.propTypes = {
  canUndo: PropType.bool,
  canRedo: PropType.bool,
  onUndo: PropType.func,
  onRedo: PropType.func,
  undoLength: PropType.number,
  redoLength: PropType.number,
};

const mapStateToProps = (state) => {
  return {
    canUndo: state.gridd.past.length > 0,
    canRedo: state.gridd.future.length > 0,
    undoLength: state.gridd.past.length,
    redoLength: state.gridd.future.length,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUndo: () => dispatch(UndoActionCreators.undo()),
    onRedo: () => dispatch(UndoActionCreators.redo()),
  };
};

UndoRedo = connect(mapStateToProps, mapDispatchToProps)(UndoRedo);
UndoRedoButtons = connect(mapStateToProps, mapDispatchToProps)(UndoRedoButtons);

export { UndoRedo, UndoRedoButtons };
